<template>
    <div class="row">
        <div class="col s12">
            <avaliacao-relatorio-list 
            />
        </div>
        
    </div>
</template>
<script>
import AvaliacaoRelatorioList from '../components/AvaliacaoRelatorioList.vue';
export default {
    name:'AvaliacaoRelatorio',
    components:{
        AvaliacaoRelatorioList
        
    }

}
</script>